var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4D4D4D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 0c.577 0 1.052.434 1.117.994l.008.131v6.75h6.75C17.496 7.875 18 8.379 18 9c0 .577-.434 1.052-.994 1.117l-.131.008h-6.75v6.75C10.125 17.496 9.621 18 9 18c-.577 0-1.052-.434-1.117-.994l-.008-.131v-6.75h-6.75C.504 10.125 0 9.621 0 9c0-.577.434-1.052.994-1.117l.131-.008h6.75v-6.75C7.875.504 8.379 0 9 0z",
    transform: "translate(-1204 -392) translate(481 374) translate(723 18)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGray);
export default __webpack_public_path__ + "static/media/plus-gray.aa73315b2c7b809f246653af51a5c764.svg";
export { ForwardRef as ReactComponent };